export default __webpack_public_path__ + "5d2bc33988e51cfe5e522b6caa3495ae.png";